export default __webpack_public_path__ + "static/laptop-b183561a4e204499a1e07dbe72020cff.webp";